import React, { Component } from 'react';

class App extends Component {
  render() {
    return (
      <div className="App">
        Projects
      </div>
    );
  }
}

export default App;
